import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from './Header';



const ModalUploadPlotsCustomersForm = () => {
    const server_app_api_php = window.SERVER_APP_API_PHP;
  const [uploadMethod, setUploadMethod] = useState('');
  const [businessLocations, setBusinessLocations] = useState([]);
  const [plots, setPlots] = useState([]);
  const [formData, setFormData] = useState({
    customersLastName: '',
    customersFirstName: '',
    customersGender: '',
    customersPhone: '',
    customersEmail: '',
    customersNationality: '',
    customersNRC: '',
    plotNumberID: '',
    business_locationIDPlotsCustomers: '',
    business_locationIDPlotsCustomersExcel: '',
    excelPlotsCustomers: null,
  });
  const [companyID, setCompanyID] = useState(1);
  const [businessLocationID, setBusinessLocationID] = useState('');
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  useEffect(() => {
    // Create formData object
    const formData = new FormData();
    formData.append("apiType", 'getBusinessLocationPlotsOnUploadForm');
    formData.append("companyID", companyID);
    formData.append("location", businessLocationID);
    // Fetch plot options from the backend using POST method
    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        setBusinessLocations(response.data);
      })
      .catch(error => {
        //alert("There was an error fetching the Business Locations!", error);
      });
    }, []);

    useEffect(() => {
        // Create formData object
        const formData = new FormData();
        formData.append("apiType", 'getPlotsOnUploadForm');
        formData.append("businessLocationID", businessLocationID);
        // Fetch plot options from the backend using POST method
        axios.post(`${server_app_api_php}/server/index.php`, formData)
          .then(response => {
            setPlots(response.data);
          })
          .catch(error => {
            //alert('There was an error fetching the plots!', error);
          });
      }, []);


  useEffect(() => {
    // Enable the submit button if all fields are filled
    const { customersLastName, customersFirstName, customersGender, customersPhone, customersEmail, customersNationality, customersNRC, plotNumberID, business_locationIDPlotsCustomers } = formData;
    if (customersLastName && customersFirstName && customersGender && customersPhone && customersEmail && customersNationality && customersNRC && plotNumberID && business_locationIDPlotsCustomers) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
  }, [formData]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, excelPlotsCustomers: e.target.files[0] });
  };

  const handleSubmitSingleForm = () => {
    const { customersLastName, customersFirstName, customersGender, customersPhone, customersEmail, customersNationality, customersNRC, plotNumberID, business_locationIDPlotsCustomers } = formData;
    const postData = {
      customersLastName : customersLastName,
			customersFirstName : customersFirstName,
			customersGender : customersGender,
			customersPhone : customersPhone,
			customersEmail : customersEmail,
			customersNationality : customersNationality,
			customersNRC : customersNRC,
			plotNumber : plotNumberID,
			companyID : companyID,
			businessLocationID : businessLocationID,
			business_locationIDPlotsCustomers : business_locationIDPlotsCustomers,
			apiType : "registerPlotsCustomers"
    };
    const formDataObj = new FormData();
    formDataObj.append('apiType', 'registerPlotsCustomers');
    formDataObj.append('customersLastName', customersLastName);
    formDataObj.append('customersFirstName', customersFirstName);
    formDataObj.append('customersGender', customersGender);
    formDataObj.append('customersPhone', customersPhone);
    formDataObj.append('customersEmail', customersEmail);
    formDataObj.append('customersNationality', customersNationality);
    formDataObj.append('customersNRC', customersNRC);
    formDataObj.append('plotNumber', plotNumberID);
    formDataObj.append('companyID', companyID);
    formDataObj.append('businessLocationID', businessLocationID);
    formDataObj.append('business_locationIDPlotsCustomers', business_locationIDPlotsCustomers);

    //console.log('what i send to server', formDataObj)
    axios.post(`${server_app_api_php}/server/index.php`, formDataObj)
    //axios.post(`${server_app_api_php}/server/index.php`, postData)
      .then((response) => {
        //console.log('what the server is getting = ', response.data);
        if (response.data === 'Successful') {
          setFormData({
            customersLastName: '',
            customersFirstName: '',
            customersGender: '',
            customersPhone: '',
            customersEmail: '',
            customersNationality: '',
            customersNRC: '',
            plotNumberID: '',
            business_locationIDPlotsCustomers: '',
            business_locationIDPlotsCustomersExcel: '',
            excelPlotsCustomers: null,
          });
          alert(response.data);
        } else {
          alert('Failed to Upload. Contact Support Team');
        }
      })
      .catch((error) => {
        alert("There Seems To be a Problem with Your Internet Connectivity. If this Problem continues, kindly contact Support Team");
      });
  };

  const handleSubmitFileUpload = (e) => {
    e.preventDefault();
    const { business_locationIDPlotsCustomersExcel, excelPlotsCustomers } = formData;
    const formDataObj = new FormData();
    formDataObj.append('excelPlotsCustomers', excelPlotsCustomers);
    formDataObj.append('companyID', companyID);
    formDataObj.append('businessLocationID', businessLocationID);
    formDataObj.append('apiType', 'registerPlotsCustomersExcel');
    formDataObj.append('business_locationIDPlotsCustomersExcel', business_locationIDPlotsCustomersExcel);

    axios.post(`${server_app_api_php}/server/index.php`, formDataObj)
      .then((response) => {
        alert(response.data);
        if (response.data === 'Upload Completed Successfully') {
          setFormData({
            customersLastName: '',
            customersFirstName: '',
            customersGender: '',
            customersPhone: '',
            customersEmail: '',
            customersNationality: '',
            customersNRC: '',
            plotNumberID: '',
            business_locationIDPlotsCustomers: '',
            business_locationIDPlotsCustomersExcel: '',
            excelPlotsCustomers: null,
          });
        } else {
          alert('Failed to Upload. Contact Support Team');
        }
      })
      .catch((error) => {
        alert("There Seems To be a Problem with Your Internet Connectivity. If this Problem continues, kindly contact Support Team");
      });
  };

  const handleUploadMethodChange = (e) => {
    setUploadMethod(e.target.value);
  };

  return (
    <>
    <Header />
    <hr />
    <div className="mt-5" id="modalUploadPlotsCustomersForm" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-lg modal-notify modal-info" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <p className="heading lead">Register Plot Customers</p>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" className="white-text">&times;</span>
            </button>
          </div>

          <div className="modal-body">
            <div className="row">
              <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                <select className="custom-select d-block w-100" id="uploadMethodPlotsCustomers" name="uploadMethodPlotsCustomers" value={uploadMethod} onChange={handleUploadMethodChange}>
                  <option value="">Choose Upload Method..</option>
                  <option value="Single Form">Single Form</option>
                  <option value="Upload Excel File">Upload Excel File</option>
                </select>
              </div>
            </div>

            {uploadMethod === 'Upload Excel File' && (
              <div className="row" id="uploadExcelFilePlotsCustomers">
                <form name="fileUploadFormPlotsCustomers" id="fileUploadFormPlotsCustomers" onSubmit={handleSubmitFileUpload}>
                  <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                    <select className="custom-select d-block w-100" id="business_locationIDPlotsCustomersExcel" name="business_locationIDPlotsCustomersExcel" required value={formData.business_locationIDPlotsCustomersExcel} onChange={handleInputChange}>
                      <option value="">Choose Business Location..</option>
                      {businessLocations.map(location => (
                        <option key={location.businessLocationID} value={location.businessLocationID}>{location.businessLocationName}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                    <label htmlFor="form22">Select Excel File</label><br />
                    <div className="md-form md-outline">
                      <input type="file" id="excelPlotsCustomers" name="excelPlotsCustomers" className="form-control form-control-sm" onChange={handleFileChange} />
                      <input type="hidden" id="companyID" name="companyID" value={companyID} />
                      <input type="hidden" id="businessLocationID" name="businessLocationID" value={businessLocationID} />
                      <input type="hidden" id="apiType" name="apiType" value="registerPlotsCustomersExcel" />
                    </div>
                  </div>
                  <div className="text-center mt-0">
                    <button className="btn btn-success" id="registerPlotsCustomersExcel" type="submit">Upload <i className="fas fa-pen-alt ml-1"></i></button>
                  </div>
                </form>
              </div>
            )}

            {uploadMethod === 'Single Form' && (
              <div className="row" id="singleFormPlotsCustomers">
                <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                  <select className="custom-select d-block w-100" id="business_locationIDPlotsCustomers" name="business_locationIDPlotsCustomers" value={formData.business_locationIDPlotsCustomers} onChange={handleInputChange}>
                    <option value="">Choose Business Location..</option>
                    {businessLocations.map(location => (
                      <option key={location.businessLocationID} value={location.businessLocationID}>{location.businessLocationName}</option>
                    ))}
                  </select>
                </div>
                <div className="col-lg-6 col-xl-6 col-md-6 md-form md-outline">
                  <input type="text" id="customersLastName" name="customersLastName" className="form-control form-control-sm" required value={formData.customersLastName} onChange={handleInputChange} />
                  <label htmlFor="customersLastName" className="active">Last Name</label>
                </div>
                <div className="col-lg-6 col-xl-6 col-md-6 md-form md-outline">
                  <input type="text" id="customersFirstName" name="customersFirstName" className="form-control form-control-sm" required value={formData.customersFirstName} onChange={handleInputChange} />
                  <label htmlFor="customersFirstName" className="active">First Name</label>
                </div>
                <div className="col-lg-6 col-xl-6 col-md-6 md-form md-outline">
                  <select className="custom-select d-block w-100" id="customersGender" name="customersGender" required value={formData.customersGender} onChange={handleInputChange}>
                    <option value="">Choose Gender..</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>
                <div className="col-lg-6 col-xl-6 col-md-6 md-form md-outline">
                  <input type="text" id="customersPhone" name="customersPhone" className="form-control form-control-sm" required value={formData.customersPhone} onChange={handleInputChange} />
                  <label htmlFor="customersPhone" className="active">Phone</label>
                </div>
                <div className="col-lg-6 col-xl-6 col-md-6 md-form md-outline">
                  <input type="email" id="customersEmail" name="customersEmail" className="form-control form-control-sm" required value={formData.customersEmail} onChange={handleInputChange} />
                  <label htmlFor="customersEmail" className="active">Email</label>
                </div>
                <div className="col-lg-6 col-xl-6 col-md-6 md-form md-outline">
                  <input type="text" id="customersNationality" name="customersNationality" className="form-control form-control-sm" required value={formData.customersNationality} onChange={handleInputChange} />
                  <label htmlFor="customersNationality" className="active">Nationality</label>
                </div>
                <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                  <input type="text" id="customersNRC" name="customersNRC" className="form-control form-control-sm" required value={formData.customersNRC} onChange={handleInputChange} />
                  <label htmlFor="customersNRC" className="active">NRC</label>
                </div>
                <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                  <select className="custom-select d-block w-100" id="plotNumberID" name="plotNumberID" required value={formData.plotNumberID} onChange={handleInputChange}>
                    <option value="">Choose Plot..</option>
                    {plots.map((plot, index) => (
    plot.businessLocationID === '3' ? (
      <option key={plot.plotsID} value={plot.plotsID}>
        Plot#= {plot.plotNumber}, Plot Price=ZMW {plot.plotPrice}, Plot Area(m²)= {plot.plotArea}
      </option>
    ) : (
      <option key={plot.plotsID} value={plot.plotsID}>
        Old Plot#= {plot.plotNumber}, New Plot#= {plot.plotNumberNew}, Old Plot Price=ZMW {plot.plotPrice}, New plot Price=ZMW {plot.plotPricesNew}, Old Plot Area(m²)= {plot.plotArea}, New Plot Area(m²)= {plot.plotAreasNew}
      </option>
    )
  ))}
                  </select>
                </div>
                <div className="text-center mt-0">
                  <button className="btn btn-success" onClick={handleSubmitSingleForm} disabled={isButtonDisabled}>Register <i className="fas fa-pen-alt ml-1"></i></button>
                </div>
              </div>
            )}
          </div>

          <div className="modal-footer justify-content-center">
            <button type="button" className="btn btn-outline-info waves-effect" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default ModalUploadPlotsCustomersForm;
